import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import classNames from 'classnames';
import styles from './OverlayPortal.module.scss.js';
import '@walmart-web/livingdesign-components/index.esm.css';
import { FocusTrap } from '@walmart-web/livingdesign-components';
import '../Alert/Alert.js';
import '../Button/Button.js';
import '../Button/ButtonGroup.js';
import '../Radio/Radio.js';
import '../Tag/Tag.js';
import '../Checkbox/Checkbox.js';
import '../Chip/Chip.js';
import { applyCommonProps } from '../utility/commonProps.js';
import '../IconButton/IconButton.js';
import '@livingdesign/icons';
import '@livingdesign/tokens/dist/js/light/regular/components/Form';
import '../TextField/TextField.js';
import '../TabNavigation/TabNavigation.js';
import '../TabNavigation/TabNavigationItem.js';
import '../Modal/Modal.js';
import '@livingdesign/tokens/dist/js/light/regular/components/ErrorMessage';
import '../SearchBox/SearchBox.js';
import '../AutoComplete/AutoComplete.js';
import '../TextArea/TextArea.js';
import '../ProgressIndicator/ProgressIndicator.js';
import '../Panel/Panel.js';
import '../Calendar/locale/wmLocale.js';
import '../Calendar/locale/stdLocale.js';
import '../Calendar/context.js';
import 'dayjs';
import '../Calendar/RenderDays.js';
import '../Calendar/RenderWeeks.js';
import '../components/Popover/Popover.js';
import '../components/InfoUnderline/InfoUnderline.js';
import '../CardActionArea/CardActionArea.js';
import '../HierarchySelector/HierarchySelector.js';
import '../Pagination/Pagination.js';
import '../DisplayTag/DisplayTag.js';
import '../PageHeader/PageHeader.js';
import '../Table/Table.js';
import '../Tooltip/Tooltip.js';
import '../ValueChange/ValueChange.js';
import '../OverlayHeader/OverlayHeader.js';
import { usePortal } from '../hooks/usePortal.js';

var _excluded = ["disableScrim", "position", "topOffset", "children", "className"];

// export type OverlayPortalProps = React.ComponentPropsWithoutRef<'div'>;

/**
 * @private
 */
var OverlayPortal = function OverlayPortal(props) {
  var _applyCommonProps = applyCommonProps(props, OverlayPortal),
    _applyCommonProps$dis = _applyCommonProps.disableScrim,
    disableScrim = _applyCommonProps$dis === void 0 ? false : _applyCommonProps$dis,
    _applyCommonProps$pos = _applyCommonProps.position,
    position = _applyCommonProps$pos === void 0 ? 'left' : _applyCommonProps$pos,
    _applyCommonProps$top = _applyCommonProps.topOffset,
    topOffset = _applyCommonProps$top === void 0 ? 0 : _applyCommonProps$top,
    children = _applyCommonProps.children,
    className = _applyCommonProps.className,
    rest = _objectWithoutProperties(_applyCommonProps, _excluded);
  var overlayPortal = usePortal();
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", _extends({
    className: classNames(disableScrim === true && position === 'right' ? styles.containerRight : '', disableScrim === true && position === 'left' ? styles.containerLeft : '', disableScrim === false ? styles.container : '', className)
  }, rest, {
    style: _objectSpread2({}, topOffset !== 0 ? {
      top: topOffset + 'em'
    } : {})
  }), !disableScrim ? /*#__PURE__*/React.createElement(FocusTrap, {
    UNSAFE_className: styles.trap
  }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children)), overlayPortal.current);
};

export { OverlayPortal };
